import { render } from "./PaymentsPanel.vue?vue&type=template&id=72766e37"
import script from "./PaymentsPanel.vue?vue&type=script&lang=js"
export * from "./PaymentsPanel.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__